export enum ProtectionMeanAdditionalType {
  ADDITIONAL = 'additional',
  ADDITIONAL_TO_PREVIOUS = 'additional_to_previous',
}
